import Vue from 'vue'
import VuePhotoGallery from 'vue-photo-gallery'

Vue.use(VuePhotoGallery)
